exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#priceBreackDown-1 {\n    width: 330px;\n}\n\n#priceBreackDown-1-heading {\n    height: 60px;\n    padding: 20px;\n    font-weight: 600;\n    font-size: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    background-color: #fafafa;\n}\n\n#priceBreackDown-1-body {\n    padding: 20px;\n}\n\n#priceBreackDown-1-body span.last-in-row {\n    float: right;\n}", ""]);

// exports
